<ng-container>
  <div class="formControl mt">
    <pr-input-radio
      formControlName="riskTolerance"
      direction="column"
      [isDefault]="false"
      [options]="options"
      columns="1"
      [derrors]="derrors"
    >
    </pr-input-radio>
  </div>
</ng-container>
